<template>
      <vs-col vs-lg="10" vs-sm="12" vs-xs="12" vs-type="flex" vs-align="center">
        <vs-row>
           <vs-col vs-lg="3" vs-sm="12" vs-xs="12" class="p-1">
             <vs-input
            placeholder="Search"
            class="w-full"
            v-model="search"
            @keyup="searchFun"
            style="width: 100%"
          />
          </vs-col>
          <vs-col vs-lg="3" vs-sm="12" vs-xs="12" class="p-1">
            <v-select class="w-full h-full" placeholder="Filter Subject" :options="subjectlist" :clearable="false" label="subject_name" @input="filterSubject($event)" @open="onOpen"
                @close="onClose"><template #list-footer>
                  <li ref="load" class="loader" v-show="subjectMeta.has_next">
                    Loading more subjects...
                  </li>
                </template></v-select>
          </vs-col>
          <vs-col v-if="$route.name != 'lessonListing' && $route.name != 'QuestionsBankList' && this.fromModule!=='topic'" vs-lg="3" vs-sm="12" vs-xs="12" class="p-1">
              <v-select
                  class="w-full"
                  :options="course_class_type_list"
                  label="name"
                  :reduce="(item) => item.value"
                  placeholder="Select Class Type"
                  @input="filterCourseType($event)"
                />
             </vs-col>
          <vs-col v-if="$route.name != 'lessonListing' && $route.name != 'QuestionsBankList' && this.fromModule!=='topic'" vs-lg="3" vs-sm="12" vs-xs="12" class="p-1">
             <v-select
                  class="w-full"
                  :options="course_session_frequency"
                  label="name"
                  :reduce="(item) => item.value"
                  placeholder="Select Session Frequency"
                   @input="filterSessionFrequency($event)"
                />
          </vs-col> 
          <!-- <vs-col vs-lg="4" vs-sm="12" vs-xs="12" class="p-1">
            <vs-button>Search</vs-button>
          </vs-col> -->
        </vs-row>
      </vs-col>
</template>

<script>
import { Subject } from '@/mixins/subject/subject'
import { mapActions} from 'vuex'
import vSelect from 'vue-select'

export default {
  mixins:[Subject],
  props: {
    fromModule: {
      type: String,
      default: 'others'
    }
  },
  mounted () {
    this.fetchSubjectList()
  },
  components: {
    vSelect
  },
  data () {
    return ({
      search:'',
      observer: new IntersectionObserver(this.loadMore),
      course_class_type_list:[
        {
          value:'self_based',
          name:'Self Paced Course'
        },
        {
          value:'online_one_2_one',
          name:'Online Individual Course'
        },
        {
          value:'online_one_2_many',
          name:'Online Group Course'
        },
        {
          value:'offline_one_2_one',
          name:'In Person Individual Course'
        },
        {
          value:'offline_one_2_many',
          name:'In Person Group Course'
        }
      ],
      course_session_frequency:[
        {
          value:1,
          name:'Daily'
        },
        {
          value:2,
          name:'Weekly'
        },
        {
          value:3,
          name:'Monthly'
        },
        {
          value:4,
          name:'Yearly'
        }
      ]
    })
  },
  methods:{
    ...mapActions(
      ['SET_HOMEWORK_SUBJECT_ID']
    ),
    async searchFun () {
      this.fetchListBySearch(this)
     
    },
    fetchListBySearch: _.debounce(async (vm) => {
      try {
        vm.$emit('SearchCourseEvent', vm.search)
      } catch (e) {
        console.log(e)
      }
    }, 1500),
    filterSubject (subject) {

      this.SET_HOMEWORK_SUBJECT_ID(subject.id)
      this.$emit('filterSubjectEvent', subject.id)

    },
    filterCourseType (course_type) {
      this.$emit('filterCourseEvent', course_type)
    },
    filterSessionFrequency (session_type) {
      this.$emit('filterSessionEvent', session_type)
    },
    async onOpen () {
      if (this.subjectMeta.has_next) {
        await this.$nextTick()
        this.observer.observe(this.$refs.load)
      }
    },
    onClose () {
      this.observer.disconnect()
    },
    async loadMore ([{isIntersecting, target}]) {
      if (isIntersecting) {
        this.loadMoreSubjects([{isIntersecting, target}])
      }
    }
  }
}
</script>
<style scoped>
.cstm_list_card .scrollable-container {
  max-height: calc(100vh - 110px);
}
</style>
